export default __webpack_public_path__ + "static/media/bottom-icon.4a39680b.png";